/** `entry_point` value telling the micro-consulting search that the client comes from the keyword search. */
export const KEYWORD_SEARCH_ENTRY_POINT = 'search';

export function buildMicroConsultingSearchUrl(query?: string): string {
    const queryParams = new URLSearchParams();

    if (query?.trim()) {
        queryParams.set('q', query.trim());
    }
    queryParams.set('entry_point', KEYWORD_SEARCH_ENTRY_POINT);

    return `/s/consulting?${queryParams}`;
}
